define.alias("shared/components/shared/color-picker/swatches", "preview-grid/components/shared/color-picker/swatches");